/* Panel — titled card with optional header-right, scroll, and footer.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';
import { Icon } from './Icon';
import type { IconName } from './Icon';

export interface PanelProps {
  title?: React.ReactNode;
  icon?: IconName;
  headerRight?: React.ReactNode;
  eyebrow?: boolean;
  className?: string;
  bodyClass?: string;
  bodyStyle?: React.CSSProperties;
  children?: React.ReactNode;
  scroll?: boolean;
  footer?: React.ReactNode;
}

export function Panel({
  title,
  icon,
  headerRight,
  eyebrow,
  className = '',
  bodyClass = '',
  bodyStyle,
  children,
  scroll,
  footer,
}: PanelProps) {
  return (
    <div className={'panel ' + className}>
      {(title || headerRight) && (
        <div className="panel-header">
          <div className="panel-title">
            {icon && (
              <Icon
                name={icon}
                size={15}
                style={{ color: 'var(--text-muted)' }}
              />
            )}
            {eyebrow ? <span className="eyebrow">{title}</span> : title}
          </div>
          {headerRight}
        </div>
      )}
      <div
        className={['panel-body grow', scroll ? 'scroll-y' : '', bodyClass]
          .filter(Boolean)
          .join(' ')}
        style={bodyStyle}
      >
        {children}
      </div>
      {footer && (
        <div
          style={{
            borderTop: '1px solid var(--border)',
            padding: '10px 14px',
            flexShrink: 0,
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
}

export default Panel;
